var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.399 2.928c.67-1.303 2.533-1.303 3.202 0l2.067 4.023 4.465.723c1.447.234 2.022 2.006.99 3.045l-3.188 3.21.693 4.47c.224 1.447-1.283 2.542-2.591 1.881L12 18.24l-4.037 2.04c-1.308.661-2.815-.434-2.59-1.882l.692-4.47-3.188-3.209c-1.032-1.04-.457-2.811.99-3.045l4.465-.723 2.067-4.023Z",
  fill: "currentColor"
})));
export default SvgStar;